import type { ForgotPasswordState } from './types';

export const initialForgotPasswordState: ForgotPasswordState = {
  email: '',
  error: undefined,
  loading: false,
  ssoCompanyId: ''
};
